import { createContext, useContext, useMemo, useState } from 'react';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, contentHasTranslations, getAssociatedContentTranslations } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
export const LanguageVariationsContext = /*#__PURE__*/createContext(undefined);
const LanguageVariationsProvider = ({
  children,
  contentObject,
  contentId
}) => {
  const [isCurrentlyViewingAllLangVariations, setIsCurrentlyViewingAllLangVariations] = useState(false);
  const allLangVariationContentIds = useMemo(() => {
    if (contentObject && isCurrentlyViewingAllLangVariations && contentHasTranslations(contentObject)) {
      const translatedContent = getAssociatedContentTranslations(contentObject);
      const allContentIds = translatedContent.map(translation => {
        const translationId = getContentPropertyValue(translation, CONTENT_PLATFORM_PROPERTY_NAME.ID);
        return `${translationId}`;
      });
      allContentIds.push(`${contentId}`);
      return allContentIds;
    }
    return undefined;
  }, [contentObject, contentId, isCurrentlyViewingAllLangVariations]);
  const value = useMemo(() => ({
    isCurrentlyViewingAllLangVariations,
    allLangVariationContentIds,
    setIsCurrentlyViewingAllLangVariations
  }), [isCurrentlyViewingAllLangVariations, allLangVariationContentIds, setIsCurrentlyViewingAllLangVariations]);
  return /*#__PURE__*/_jsx(LanguageVariationsContext.Provider, {
    value: value,
    children: children
  });
};
export default LanguageVariationsProvider;
export function useLanguageVariationsProvider() {
  const context = useContext(LanguageVariationsContext);
  if (context === undefined) {
    throw new Error('useLanguageVariationsProvider must be used within a LanguageVariationsProvider');
  }
  return context;
}